import { render, staticRenderFns } from "./ReporteDeudores.vue?vue&type=template&id=6d65a980"
import script from "./ReporteDeudores.vue?vue&type=script&lang=js"
export * from "./ReporteDeudores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports